import { GridFooterContainer, GridSlotsComponentsProps } from '@mui/x-data-grid-pro';
import { Box, Typography } from '@mui/material';
import React from 'react';

const DataGridFooter = (props: NonNullable<GridSlotsComponentsProps['footer']>) => {
    return (
        <GridFooterContainer>
            {props.summary && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        flexWrap: 'wrap',
                        gap: 1,
                        padding: 1,
                    }}>
                    <Typography variant='h6'>Összegzés</Typography>
                    <Box sx={{ display: 'flex' }}>
                        {Object.keys(props.summary).map((key, index) => (
                            <Typography key={index} variant='body2' px={1.25}>
                                {props.summary ? props.summary[key] : 0}
                            </Typography>
                        ))}
                    </Box>
                </Box>
            )}
        </GridFooterContainer>
    );
};

export default DataGridFooter;